<template>
  <div>
    <section-title
      content="Información de Lugar(es) de Servicio"
      :has-line="true"
    />
    <div>
      <custom-callout
        v-for="(location, idx) in data"
        :key="idx"
        :border-color="'gray'"
        class-main="mt-1 rounded mb-2"
        :has-toggle="false"
        :opened="false"
      >
        <div class="row py-2">
          <div class="col-md-3">
            <div class="color-gray-6 font-14">Tipo de Lugar:</div>
            <div class="color-black font-16">
              {{ location.locationType.name | empty }}
            </div>
          </div>
          <div class="col-md-2">
            <div class="color-gray-6 font-14">Municipio:</div>
            <div class="color-black font-16">
              {{ location.municipality.name | empty }}
            </div>
          </div>
          <div class="col-md-3">
            <div class="color-gray-6 font-14">Escuela:</div>
            <div class="color-black font-16">
              {{ location.locationService.name | empty }}
            </div>
          </div>
          <div class="col">
            <div class="float-right mr-2">
              <drop-down :data-item="idx" :items="actionsItems" />
            </div>
          </div>
        </div>
      </custom-callout>
      <div v-if="!showForm" class="d-flex flex-row-reverse mt-3">
        <action-button
          i="fas fa-file-medical fa-lg"
          text="Añadir"
          variant="success"
          @click="onAddHandler"
        />
      </div>
      <div v-else>
        <div id="formDiv" class="bg-secondary-3 rounded p-4">
          <validation-observer
            :ref="'locationServiceForm'"
            v-slot="{}"
            tag="form"
          >
            <div v-if="specialistLicenseDisciplines.length > 0" class="row">
              <div class="col-md-12 text-gray mb-2">
                Seleccione la(s) Disciplina(s) de Licencia(s) a las que desea
                añadir Lugar(es) de Servicio(s)
              </div>
              <div class="col-md-12">
                <div
                  class="
                    col-12
                    overflow-auto
                    max-height-100
                    border
                    rounded
                    bg-white
                    p-3
                  "
                >
                  <div
                    v-for="licenseDisciplines in specialistLicenseDisciplines"
                    :key="licenseDisciplines.specialistLicenseId"
                    class="mb-3"
                  >
                    <div class="license-label mb-2">
                      {{ licenseDisciplines.licenseSpecialtyName }}
                    </div>
                    <div class="mt-1 disciplines-container">
                      <div
                        v-for="licenseDiscipline in licenseDisciplines.licenseDiscipline"
                        :key="licenseDiscipline.discipline.id"
                      >
                        <check-box
                          v-model="licenseDiscipline.discipline.selected"
                          class="discipline-checkbox"
                          :text="licenseDiscipline.discipline.name"
                          @input="
                            onCheckDiscipline($event, licenseDiscipline, true)
                          "
                        />
                        <div
                          v-if="licenseDiscipline.subDisciplines.length > 0"
                          class="ml-4"
                        >
                          <div
                            v-for="subDiscipline in licenseDiscipline.subDisciplines"
                            :key="subDiscipline.id"
                          >
                            <check-box
                              v-model="subDiscipline.selected"
                              class="discipline-checkbox"
                              :text="subDiscipline.name"
                              @input="
                                onCheckSubDiscipline(
                                  licenseDiscipline.discipline
                                )
                              "
                            />
                          </div>
                          <div
                            v-if="licenseDiscipline.subDisciplines.length > 0"
                            class="ml-4"
                          >
                            <div
                              v-for="subDiscipline in licenseDiscipline.subDisciplines"
                              :key="subDiscipline.id"
                            >
                              <check-box
                                v-model="subDiscipline.selected"
                                class="discipline-checkbox"
                                :text="subDiscipline.name"
                                @input="
                                  onCheckDiscipline(
                                    undefined,
                                    licenseDiscipline,
                                    false
                                  )
                                "
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <error
                  v-if="!hasValidDiscipline"
                  class="col-12 mx-3 mb-2"
                  :message="
                    'Favor seleccionar la(s) Disciplina(s) de Licencia(s) a la(s) que desea añadir Lugar(es) de Servicio(s).'
                  "
                  variant="no-border"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <label class="data-title mb-0">Tipo de Lugar:</label>
                <validation-provider
                  v-slot="{ errors }"
                  name="specialistLocationType"
                  rules="required"
                >
                  <custom-drop-down
                    v-model="model.locationTypeId"
                    :clearable="false"
                    custom-error-msg="El tipo de lugar es requerido."
                    :error="errors[0]"
                    fieldkey="id"
                    fieldname="name"
                    :options="locationTypes"
                    @input="onChangeLocationType"
                  />
                </validation-provider>
              </div>
              <div class="col-md-4">
                <label class="data-title mb-0">Municipio:</label>
                <validation-provider
                  v-slot="{ errors }"
                  name="specialistMunicipality"
                  rules="required"
                >
                  <custom-drop-down
                    v-model="model.municipalityId"
                    :clearable="false"
                    custom-error-msg="El municipio es requerido."
                    :disabled="!model.locationTypeId"
                    :error="errors[0]"
                    fieldkey="id"
                    fieldname="name"
                    :options="municipalities"
                    @input="onChangeMunicipality"
                  />
                </validation-provider>
              </div>
              <div class="col-md-4">
                <label class="data-title mb-0">Lugar de Servicio:</label>
                <validation-provider
                  v-slot="{ errors }"
                  name="specialistLocationService"
                  rules="required"
                >
                  <custom-drop-down
                    v-model="model.locationServiceId"
                    :clearable="false"
                    custom-error-msg="El lugar de servicio es requerido."
                    :disabled="!model.municipalityId"
                    :error="errors[0]"
                    fieldkey="id"
                    fieldname="name"
                    :options="locationServices"
                  />
                </validation-provider>
              </div>
            </div>
            <div class="row">
              <div class="col-12 mt-3 mr-3">
                <div class="d-flex flex-row-reverse bd-highlight w-100 actions">
                  <div class="bd-highlight ml-2">
                    <action-button
                      :i="saveActionIcon"
                      :text="saveActionText"
                      variant="success"
                      @click="onSubmit"
                    />
                  </div>
                  <div class="mx-0 bd-highlight">
                    <action-button
                      id="modal-btn-cancelar"
                      i="fas fa-times-circle"
                      text="Cancelar"
                      variant="outline-danger"
                      @click="onCancel"
                    />
                  </div>
                </div>
              </div>
            </div>
          </validation-observer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomCallout from 'custom-callout';
import CustomDropDown from 'custom-drop-down';
import DropDown from 'dropdown';
import ActionButton from 'ActionButton';
import CheckBox from 'CheckBox';
import Error from 'custom-error';
import SectionTitle from 'SectionTitle';
import { ValidationProvider } from 'vee-validate';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import { getMunicipalitiesByProvider as _getMunicipalitiesByProvider } from '@/services/common/location.api.js';
import { getLocationTypes as _getLocationTypes } from '@/services/common/code.api.js';
import { getlocationServices as _getlocationServices } from '@/services/provider/location-service.api.js';
import {
  getAllDisciplinesBySpecialtyType as _getAllDisciplinesBySpecialtyType,
  getSpecialistLicenseDisciplines as _getSpecialistLicenseDisciplines,
  deleteSpecialistLocation as _deleteSpecialistLocation,
} from '@/services/provider/specialist.api.js';
import disciplineTypes from '@/utils/constants/disciplineTypes.js';
import CodeLocationTypes from '@/utils/constants/codeLocationTypes';

export default {
  name: 'SpecialistLocationServiceRow',
  components: {
    CustomCallout,
    CustomDropDown,
    ActionButton,
    CheckBox,
    ValidationProvider,
    DropDown,
    Error,
    SectionTitle,
  },
  mixins: [alertMixin],
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    specialtyTypeId: {
      type: Array,
      default: () => [],
    },
    specialistId: {
      type: Number,
      default: () => 0,
    },
    showLocationServiceForm: {
      type: Boolean,
      default: () => false,
    },
    showForm: {
      type: Boolean,
      default: () => false,
    },
    academicYear: {
      type: Number,
      default: () => 0,
    },
  },
  data() {
    return {
      model: {},
      municipalities: [],
      locationServices: [],
      specialistLicenseDisciplines: [],
      locationTypes: [],
      hasValidDiscipline: true,
      isEditMode: false,
      locationServiceSelected: null,
    };
  },
  computed: {
    academicYearId() {
      return this.academicYear != undefined && this.academicYear > 0
        ? this.academicYear
        : this.currentAcademicYearId;
    },
    companyId() {
      return +this.$route.params.companyId || null;
    },
    actionsItems() {
      let actions = [
        {
          label: 'Editar',
          icon: 'fas fa-edit color-primary-1',
          visible: this.userHasPermissions(
            'rempro.specialist.editlocationservice'
          ),
          click: (e) => {
            this.onEdit(e);
          },
        },
        {
          label: 'Eliminar',
          icon: 'fas fa-times-circle text-danger',
          click: (e) => {
            this.onDelete(e);
          },
          visible:
            this.data.length > 1 &&
            this.userHasPermissions('rempro.specialist.deletelocationservice'),
        },
      ];

      return actions;
    },
    saveActionText() {
      return this.isEditMode ? 'Guardar' : 'Añadir';
    },
    saveActionIcon() {
      return `fas ${this.isEditMode ? 'fa-save' : 'fa-file-medical'} fa-lg`;
    },
    excludedLocationTypes() {
      return [CodeLocationTypes.CAAT, CodeLocationTypes.CSEE];
    },
  },
  mounted() {
    this.fetchDisciplines(this.specialtyTypeId);
  },
  methods: {
    async onAddHandler() {
      this.$emit('update:showLocationServiceForm', true);
      const { data } = await _getSpecialistLicenseDisciplines(
        this.specialistId
      );
      if (data.length > 0) this.specialistLicenseDisciplines = data;
      this.moveDown();
    },
    onCancel() {
      this.$emit('update:showLocationServiceForm', false);
      this.isEditMode = false;
      this.clear();
      this.$emit('cancel');
    },
    async fetchMunicipalities() {
      const { data } = await _getMunicipalitiesByProvider(
        this.academicYearId,
        this.companyId,
        this.model.locationTypeId.id
      );
      this.municipalities = data;
    },
    async fetchLocationTypes() {
      const { data } = await _getLocationTypes(this.excludedLocationTypes);
      this.locationTypes = data;
    },
    async fetchLocationServices() {
      const payload = {
        academicYear: this.academicYearId,
        provider: this.companyId,
        locationType: this.model.locationTypeId.id,
        municipality: this.model.municipalityId.id,
      };
      const { data: locations } = await _getlocationServices(payload);

      let itemsToExclude = this.data
        .map((item) => item.locationService.id)
        .filter((x) => x !== this.locationServiceSelected?.id);

      this.locationServices = locations.filter(
        (item) => !itemsToExclude.includes(item.id)
      );
    },
    async onChangeLocationType(value) {
      this.model.locationTypeId = value;
      this.model.municipalityId = null;
      this.model.locationServiceId = null;
      this.fetchMunicipalities();
    },
    async onChangeMunicipality(value) {
      this.model.municipalityId = value;
      this.model.locationServiceId = null;
      this.fetchLocationServices();
    },
    onCheckDiscipline(chechked, discipline, isDiscipline) {
      if (
        discipline?.discipline?.id ===
          disciplineTypes.TerapiaEntrenamientoAuditivo &&
        isDiscipline
      ) {
        discipline.discipline.selected = chechked;
        if (!chechked) {
          discipline.subDisciplines.forEach((subDiscipline) => {
            subDiscipline.selected = false;
          });
        }
      } else {
        if (discipline?.subDisciplines.some((x) => x.selected))
          discipline.discipline.selected = true;
      }

      this.hasValidDiscipline = true;
      const disciplines = this.specialistLicenseDisciplines.map((x) => {
        return {
          specialistLicenseId: x.specialistLicenseId,
          licenseSpecialtyName: x.licenseSpecialtyName,
          disciplines: x.licenseDiscipline
            .filter((y) => y.discipline.selected)
            .map((d) => {
              const { discipline } = d;
              return {
                disciplineId: discipline.id,
                disciplineName: discipline.name,
                subDisciplines: d.subDisciplines
                  .filter((sub) => sub.selected)
                  .map((sub) => {
                    return {
                      subDisciplineId: sub.id,
                      subDisciplineName: sub.name,
                    };
                  }),
              };
            }),
        };
      });

      this.model.disciplines = disciplines.filter(
        (x) => x.disciplines.length > 0
      );
    },
    onCheckSubDiscipline(discipline) {
      discipline.selected = true;
      this.onCheckDiscipline();
    },
    async onSubmit() {
      this.hasValidDiscipline = this.specialistLicenseDisciplines.some((x) =>
        x.licenseDiscipline.some((e) => e.discipline.selected)
      );

      const AuditoryTrainingTherapy = this.model?.disciplines
        ?.map((x) => x.disciplines)
        .flat()
        .find(
          (x) => x.disciplineId === disciplineTypes.TerapiaEntrenamientoAuditivo
        );

      if (AuditoryTrainingTherapy) {
        if (AuditoryTrainingTherapy.subDisciplines.length === 0) {
          this.ShowToast(
            'Alerta',
            'Favor seleccionar al menos una subdisciplina para la terapia de Entrenamiento Auditivo.',
            'error'
          );
          return;
        }
      }

      const isFormValid =
        (await this.$refs['locationServiceForm'].validate()) &&
        this.hasValidDiscipline;

      if (!isFormValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        );
        return;
      }
      if (!this.isEditMode) {
        this.$emit('on-add-location-service', this.model, () => {
          this.clear();
          this.onCancel();
        });
      } else {
        this.onCheckDiscipline();
        this.$emit(
          'on-edit-location-service',
          {
            model: this.model,
            locationServiceSelected: this.locationServiceSelected,
          },
          () => {
            this.clear();
            this.onCancel();
          }
        );
      }
    },
    async fetchDisciplines(types) {
      const { data } = await _getAllDisciplinesBySpecialtyType(types);
      if (data.length > 0) this.specialistLicenseDisciplines = data;
    },
    clear() {
      this.model = {};
      this.specialistLicenseDisciplines?.forEach((element) => {
        element.licenseDiscipline.forEach((x) => (x.selected = false));
      });
    },
    async onEdit(index) {
      this.isEditMode = true;
      const modelDb = this.data[index];
      this.model.locationTypeId = modelDb.locationType;
      this.model.municipalityId = modelDb.municipality;
      this.model.locationServiceId = modelDb.locationService;
      this.locationServiceSelected = modelDb.locationService;
      this.model.specialistLocationId = modelDb.specialistLocationId;
      const { data } = await _getSpecialistLicenseDisciplines(
        this.specialistId
      );
      if (data.length > 0) {
        this.specialistLicenseDisciplines = data;

        this.specialistLicenseDisciplines.forEach((element) => {
          element.licenseDiscipline.forEach((x) => {
            if (
              modelDb.disciplines.some(
                (e) => e.disciplineId === x.discipline.id
              )
            ) {
              x.discipline.selected = true;
              const subDisciplines = modelDb.disciplines
                .filter((y) => y.disciplineId === x.discipline.id)
                .map((y) => y.subDisciplinesTypes)
                .flat();

              subDisciplines.forEach((sub) => {
                if (
                  x.subDisciplines.some((e) => e.id === sub.subDisciplineId)
                ) {
                  x.subDisciplines.find(
                    (e) => e.id === sub.subDisciplineId
                  ).selected = true;
                }
              });
            }
          });
        });
      } else {
        this.specialistLicenseDisciplines.forEach((element) => {
          element.licenseDiscipline.forEach((x) => {
            if (
              modelDb.disciplines
                .map((dis) => dis.disciplines)
                .flat()
                .some((e) => e.disciplineId === x.discipline.id)
            ) {
              x.discipline.selected = true;
              const subDisciplines = modelDb.disciplines
                .map((dis) => dis.disciplines)
                .flat()
                .filter((y) => y.disciplineId === x.discipline.id)
                .map((y) => y.subDisciplines)
                .flat();

              subDisciplines.forEach((sub) => {
                if (
                  x.subDisciplines.some((e) => e.id === sub.subDisciplineId)
                ) {
                  x.subDisciplines.find(
                    (e) => e.id === sub.subDisciplineId
                  ).selected = true;
                }
              });
            }
          });
        });
      }
      this.fetchMunicipalities();
      this.fetchLocationServices();
      this.$emit('update:showLocationServiceForm', true);

      this.moveDown();
    },
    async onDelete(index) {
      const modelDb = this.data[index];
      const answer = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro(a) que desea eliminar el lugar de servicio seleccionado?`,
        'Sí',
        'No'
      );
      if (!answer) return;

      await _deleteSpecialistLocation(modelDb.specialistLocationId).then(() => {
        this.ShowToast(
          `Confirmación`,
          'El lugar de servicio ha sido eliminado exitosamente.',
          'success'
        );
        this.$emit('on-delete-location');
      });
    },
    moveDown() {
      this.$nextTick(() => {
        const scrollDiv = document.getElementById('formDiv').offsetTop;
        window.scrollTo({ top: scrollDiv, behavior: 'smooth' });
      });
    },
  },
  watch: {
    showForm: function(value) {
      if (value) {
        this.fetchLocationTypes();
        return;
      }
    },
    specialtyTypeId: function(value) {
      this.fetchDisciplines(value);
    },
    showLocationServiceForm: function(value) {
      if (!value) {
        this.showForm = false;
      }
    },
  },
};
</script>
<style scoped lang="scss">
@import '~@/shared/scss/config/colors.scss';

.mobile {
  padding: 0.5rem;
}

.col-md-20 {
  flex: 0 0 20%;
  width: 20%;
}

.col-md-18 {
  flex: 0 0 18%;
  width: 18%;
}

.license-label {
  color: map-get($colors, 'gray-7');
  font-weight: bold;
}

.disciplines-container .discipline-checkbox {
  font-weight: normal;
  color: map-get($colors, 'gray-6');
}

::v-deep input[type='checkbox']:checked + label span {
  background-color: map-get($colors, 'green') !important;
}

::v-deep input[type='checkbox']:checked + label span em {
  filter: brightness(0) invert(1);
}

.license-disciplines-title {
  margin-left: 24px;
  padding: 7px 16px;
  font-weight: normal;
  color: map-get($colors, 'gray-6');
}

.max-height-100 {
  max-height: 300px !important;
}
</style>
